import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { useParams } from 'react-router-dom'
import API from '../../../../services/API'
import DetailsBox, { DetailRow } from '../../../../components/Cards/DetailsBox'
import Alert from '@mui/material/Alert'
import LinearProgress from '@mui/material/LinearProgress'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { Chip, Link, Paper } from '@mui/material'
import { isFullWidth } from 'validator'
import LogsComponent from '../../../../components/Logs/LogsComponent'

const ShiftApplicationView = () => {
  const { employeeID, applicationID } = useParams()
  const [loading, setLoading] = useState(true)
  const [fetchError, setFetchError] = useState(false)
  const [application, setApplication] = useState({})
  const [employee, setEmployee] = useState({})

  useEffect(() => {
    API.get(
      `/employees/shift-application-history/${employeeID}/${applicationID}`,
    )
      .then((res) => {
        if (res.status === 200) {
          setApplication(res.data.application)
          setEmployee(res.data.user)
          console.log(res.data)
        }
      })
      .catch(() => setFetchError(true))
      .finally(() => setLoading(false))
  }, [])

  return (
    <Stack gap={1}>
      <Typography variant="title2">Shift Application</Typography>
      {loading ? (
        <LinearProgress />
      ) : fetchError ? (
        <Alert severity="error">
          Unable to fetch Shift Application. Please try again later.
        </Alert>
      ) : (
        <Stack gap={1}>
          <Typography variant="title3">
            {employee.firstName} {employee.lastName}
          </Typography>
          <Chip
            sx={{ borderRadius: 1 }}
            color={
              application.status === 'Pending'
                ? 'anOrange'
                : application.status === 'Accepted'
                  ? 'success'
                  : 'error'
            }
            label={application.status}
          />
          <DetailsBox
            component={Paper}
            padding={1}
            title="Application"
            rows={[
              {
                label: 'Application Date',
                value: moment(application.createdAt).format(
                  'Do MMM YYYY HH:mm',
                ),
                fullWidth: true,
                fullWidthLabel: true
              },

              {
                label: 'Event Status at time of Application',
                value: application.eventStatusAtTimeOfApplication,
                fullWidth: true,
                fullWidthLabel: true
              },
            ]}
          >
            {application.status === 'Rejected' && (
              <DetailRow
                label="Rejected Reason"
                value={application.rejectedReason}
                fullWidthLabel
                fullWidth
              />
            )}
            {application.status !== 'Pending' && application.reviewedBy && (
              <DetailRow
                label="Reviewed By"
                value={`${application.reviewedBy.firstName} ${application.reviewedBy.lastName}`}
              />
            )}
          </DetailsBox>
          <DetailsBox
            component={Paper}
            padding={1}
            title="Shift"
            rows={[
              {
                label: application.shift?.event ? 'Event' : 'Type',
                value: application.shift?.event?.title ? (
                  <Link
                    href={`/events/${application.shift.event._id}`}
                    target="_blank"
                  >
                    {application.shift.event.title}
                  </Link>
                ) : (
                  (application.shift?.shiftType ?? '')
                ),
              },
              {
                label: 'Shift Start',
                value: moment(application.shift.start).format(
                  'HH:mm [(]DD/MM/YY[)]',
                ),
              },
              {
                label: 'Shift End',
                value: moment(application.shift.end).format(
                  'HH:mm [(]DD/MM/YY[)]',
                ),
              },
              {
                label: 'Clinical Role',
                value: application.shift.clinicalRole,
              },
              {
                label: 'Event Role',
                value: application.shift.eventAssignment,
              },
              {
                label: 'Pay Rate',
                value: `${application.shift.payRate}/${application.shift.hourlyRate ? 'hr' : 'shift'
                  }`,
              },
            ]}
          >
            {application.shift.logs.length > 0 && (
              <LogsComponent targetId={application.shift._id} targetType='shift' title="Note" allowCreateLog />
            )}
          </DetailsBox>
        </Stack>
      )}
    </Stack>
  )
}

export default ShiftApplicationView
